(function netaiSupabaseCatalogueRecovery(window, document) {
  'use strict';
  var URL_ROOT = 'https://avmchfexbmqwseregils.supabase.co';
  var API_KEY = 'sb_publishable_Xb99RAufZwOYcNx_JewP7g_KJp1z1zX';
  var cache = { products: null, bySlug: new Map() };

  function request(path, query) {
    var params = new URLSearchParams(query || {});
    var url = URL_ROOT + '/rest/v1/' + path + '?' + params.toString();
    return fetch(url, { headers: { apikey: API_KEY, Authorization: 'Bearer ' + API_KEY, Accept: 'application/json' }, credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Supabase catalogue request failed: ' + response.status + ' ' + path);
        return response.json();
      });
  }

  function variant(row) {
    return {
      id: row.id,
      legacyId: row.legacy_shopify_variant_id,
      title: row.title || 'Default Title',
      option1: row.option_1 || null,
      option2: row.option_2 || null,
      option3: row.option_3 || null,
      price: Number(row.price || 0),
      compareAtPrice: row.compare_at_price == null ? null : Number(row.compare_at_price),
      inventoryQuantity: row.inventory_quantity == null ? null : Number(row.inventory_quantity),
      available: row.inventory_quantity == null ? 'unknown' : Number(row.inventory_quantity) > 0 ? 'available' : 'sold-out'
    };
  }

  function loadProducts(query) {
    return request('products', query).then(function (rows) {
      rows = Array.isArray(rows) ? rows : [];
      var ids = rows.map(function (row) { return row.id; });
      if (!ids.length) return [];
      var idFilter = 'in.(' + ids.join(',') + ')';
      return Promise.all([
        request('product_variants', { select: 'product_id,id,legacy_shopify_variant_id,title,option_1,option_2,option_3,price,compare_at_price,inventory_quantity,active', product_id: idFilter, order: 'id.asc' }),
        request('product_media', { select: 'id,product_id,variant_id,url,storage_path,alt_text,sort_order,media_type', product_id: idFilter, media_type: 'eq.image', order: 'sort_order.asc' })
      ]).then(function (parts) {
        var variantsByProduct = new Map(), mediaByProduct = new Map();
        (parts[0] || []).forEach(function (row) {
          if (row.active === false) return;
          if (!variantsByProduct.has(row.product_id)) variantsByProduct.set(row.product_id, []);
          variantsByProduct.get(row.product_id).push(variant(row));
        });
        (parts[1] || []).forEach(function (row) {
          if (!row.url) return;
          if (!mediaByProduct.has(row.product_id)) mediaByProduct.set(row.product_id, []);
          mediaByProduct.get(row.product_id).push(row);
        });
        return rows.map(function (row) {
          var media = (mediaByProduct.get(row.id) || []).sort(function (a, b) { return Number(a.sort_order || 0) - Number(b.sort_order || 0); });
          var product = {
            id: row.id, name: row.name || '', slug: row.slug || '', description: row.description || '',
            shortDescription: row.short_description || '', status: row.status, productType: row.product_type || '',
            variants: variantsByProduct.get(row.id) || [], media: media, primaryMedia: media[0] || null
          };
          cache.bySlug.set(product.slug, product);
          return product;
        });
      });
    });
  }

  function published(query) {
    query = query || {};
    if (!Object.keys(query).length && cache.products) return Promise.resolve(cache.products.slice());
    var params = Object.assign({ select: 'id,name,slug,description,short_description,product_type,status,featured,created_at,updated_at', status: 'eq.active', order: 'name.asc' }, query);
    return loadProducts(params).then(function (products) {
      if (!Object.keys(query).length) cache.products = products.slice();
      return products;
    });
  }

  function bySlug(slug) {
    if (cache.bySlug.has(slug)) return Promise.resolve(cache.bySlug.get(slug));
    return loadProducts({ select: 'id,name,slug,description,short_description,product_type,status,featured,created_at,updated_at', slug: 'eq.' + encodeURIComponent(slug), status: 'eq.active', limit: '1' })
      .then(function (products) { return products[0] || null; });
  }

  function state(product) {
    var variants = product && product.variants || [];
    if (!variants.length) return 'unknown';
    if (variants.some(function (v) { return v.available === 'available'; })) return 'available';
    if (variants.some(function (v) { return v.available === 'unknown'; })) return 'unknown';
    return 'sold-out';
  }

  function money(value) {
    return 'KSh' + Number(value || 0).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function image(img, media) {
    if (!img || !media || !media.url) return;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.src = media.url;
    img.srcset = media.url;
    if (media.alt_text != null) img.alt = media.alt_text;
  }

  function updateCard(card, product) {
    var v = product.variants[0] || null;
    var compare = v && v.compareAtPrice != null && v.compareAtPrice > v.price;
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = '/products/' + product.slug; });
    card.querySelectorAll('.card-title').forEach(function (n) { n.textContent = product.name; });
    card.querySelectorAll('.price-item--sale,.price__last').forEach(function (n) { n.textContent = money(v ? v.price : 0); });
    card.querySelectorAll('.price__compare,.price-item--regular').forEach(function (n) {
      n.textContent = money(compare ? v.compareAtPrice : (v ? v.price : 0));
      if (n.classList.contains('price__compare')) n.style.display = compare ? '' : 'none';
    });
    if (product.media.length) card.querySelectorAll('img').forEach(function (img, i) { image(img, product.media[Math.min(i, product.media.length - 1)]); });
    card.dataset.netaiAvailability = state(product);
    card.dataset.netaiSupabaseProductId = product.id;
  }

  function updateCards(products) {
    var bySlugMap = new Map(products.map(function (p) { return [p.slug, p]; }));
    document.querySelectorAll('.product-item').forEach(function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      var product = m && bySlugMap.get(decodeURIComponent(m[1]));
      if (product) updateCard(card, product);
      else if (m) card.hidden = true;
    });
  }

  function updateProduct(product) {
    if (!product) return;
    var v = product.variants[0] || null;
    document.querySelectorAll('.productView-title').forEach(function (n) { n.textContent = product.name; });
    document.querySelectorAll('.productView-price .price-item--sale,.productView-price .price__last,.productView-info + .price .price-item--sale').forEach(function (n) { n.textContent = money(v ? v.price : 0); });
    document.querySelectorAll('.productView-images img').forEach(function (img, i) {
      if (product.media[i]) image(img, product.media[i]);
      else if (img.closest('.productView-image')) img.closest('.productView-image').hidden = true;
    });
    var first = v;
    var variantByLegacy = new Map((product.variants || []).map(function (item) { return [String(item.legacyId), item]; }));
    var controls = Array.from(document.querySelectorAll('select[name^="stick-variant-"], input[type="radio"][name^="stick-variant-"]'));
    function applySelectedVariant() {
      var control = controls.filter(function (node) { return node.tagName === 'SELECT' || node.checked; })[0];
      var selectedId = control ? control.value : (first && first.legacyId);
      var selected = variantByLegacy.get(String(selectedId)) || first;
      var selectedState = !selected ? 'unknown' : selected.inventoryQuantity == null ? 'unknown' : selected.inventoryQuantity > 0 ? 'available' : 'sold-out';
      document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) { if (selected && (selected.legacyId || selectedId)) input.value = selected.legacyId || selectedId; });
      document.querySelectorAll('.productView-price .price-item--sale,.productView-price .price__last,.productView-info + .price .price-item--sale').forEach(function (node) { if (selected) node.textContent = money(selected.price); });
      document.querySelectorAll('.productView-price .price__compare,.productView-price .price-item--regular').forEach(function (node) { var showCompare = selected && selected.compareAtPrice != null && selected.compareAtPrice > selected.price; node.textContent = money(showCompare ? selected.compareAtPrice : (selected ? selected.price : 0)); if (node.classList.contains('price__compare')) node.style.display = showCompare ? '' : 'none'; });
      document.querySelectorAll('[data-btn-addtocart]').forEach(function (button) { button.dataset.available = selectedState === 'sold-out' ? 'false' : 'true'; button.disabled = selectedState === 'sold-out'; if (selectedState === 'sold-out') button.textContent = 'Sold out'; });
      document.documentElement.dataset.netaiSupabaseAvailability = selectedState;
    }
    controls.forEach(function (control) { control.addEventListener('change', applySelectedVariant); });
    applySelectedVariant();
    setTimeout(applySelectedVariant, 250);
    setTimeout(applySelectedVariant, 1500);
    var syncAttempts = 0;
    var syncTimer = setInterval(function () { applySelectedVariant(); syncAttempts += 1; if (syncAttempts > 20) clearInterval(syncTimer); }, 500);
    document.documentElement.dataset.netaiSupabaseProduct = product.slug;
    document.documentElement.dataset.netaiSupabaseAvailability = state(product);
  }

  function boot() {
    var path = window.location.pathname;
    var p = path.match(/^\/products\/([^/?#]+)/);
    if (p) return bySlug(decodeURIComponent(p[1])).then(updateProduct);
    var c = path.match(/^\/collections\/([^/?#]+)/);
    if (c && c[1] === 'all') return published().then(updateCards);
    if (c && c[1] !== 'vendors') {
      return request('collections', { select: 'id,slug', slug: 'eq.' + encodeURIComponent(c[1]), limit: '1' })
        .then(function (rows) { return rows[0] ? request('product_collections', { select: 'product_id,sort_order', collection_id: 'eq.' + rows[0].id, order: 'sort_order.asc' }) : []; })
        .then(function (links) {
          var ids = links.map(function (x) { return x.product_id; });
          return ids.length ? loadProducts({ select: 'id,name,slug,description,short_description,product_type,status,featured,created_at,updated_at', id: 'in.(' + ids.join(',') + ')', status: 'eq.active', order: 'name.asc' }) : [];
        })
        .then(updateCards);
    }
    if (path === '/search') {
      var term = new URLSearchParams(window.location.search).get('q') || '';
      var searchQuery = term ? { or: '(name.ilike.*' + term + '*,description.ilike.*' + term + '*,product_type.ilike.*' + term + '*)' } : {};
      return published(searchQuery).then(updateCards);
    }
    return published().then(updateCards);
  }

  var api = { getProducts: published, getPublishedProducts: published, getProductBySlug: bySlug, refresh: boot, config: { url: URL_ROOT, bucket: 'product-images' } };
  window.NetaiCatalogue = api;
  boot().catch(function (error) { console.warn('[Netai] Supabase catalogue recovery failed; Shopify content left intact.', error); });
})(window, document);
